// extracted by mini-css-extract-plugin
module.exports = {"preloader":"Preloader_preloader__2ibNK","girar":"Preloader_girar__2drFd"};